import './StatutsBarre.css';

/**
 * Pastilles de filtre posées au-dessus d'une liste : chacune porte son nombre
 * et filtre la table au clic.
 *
 * Générique : chaque page fournit ses propres facettes via `options`
 * (cf. facettes.js). Les vocabulaires diffèrent d'une étape à l'autre —
 * statut de traitement pour les demandes, statut de devis, état de signature
 * pour les contrats, urgence pour les relances, situation de la séance pour
 * les documents — et une page ne doit proposer que ce qui la concerne.
 *
 * `compteurs` vient du serveur et ignore la facette sélectionnée : les nombres
 * ne bougent donc pas au clic, seule la table est filtrée.
 */
function StatutsBarre({
  options,
  compteurs,
  valeur,
  total,
  onSelect,
  libelleTous = 'Toutes',
  titre,
}) {
  const nombre = (cle) => Number(compteurs?.[cle]) || 0;

  return (
    <div className="statuts-barre" role="group" aria-label={titre || 'Filtrer'}>
      {/* Une page peut poser deux rangées de pastilles sur deux dimensions
          indépendantes (la séance, l'envoi) : le titre dit laquelle on filtre. */}
      {titre && <span className="statuts-barre-titre">{titre}</span>}

      <button
        type="button"
        className={'statut-chip statut-chip-tous' + (valeur ? '' : ' statut-chip-actif')}
        onClick={() => onSelect('')}
        aria-pressed={!valeur}
      >
        <span className="statut-chip-label">{libelleTous}</span>
        <span className="statut-chip-nombre">{total}</span>
      </button>

      {options.map((opt) => {
        const n = nombre(opt.cle);
        const actif = valeur === opt.cle;
        return (
          <button
            key={opt.cle}
            type="button"
            // Une facette vide ne mène qu'à une table vide : on la montre (le
            // vocabulaire complet reste lisible) mais on la rend inerte.
            disabled={n === 0 && !actif}
            className={
              `statut-chip ${opt.classe}` +
              (actif ? ' statut-chip-actif' : '') +
              (n === 0 ? ' statut-chip-vide' : '')
            }
            // Recliquer la pastille active retire le filtre : c'est le geste
            // attendu quand elle est déjà sélectionnée.
            onClick={() => onSelect(actif ? '' : opt.cle)}
            aria-pressed={actif}
          >
            <span className="statut-chip-puce" aria-hidden="true" />
            <span className="statut-chip-label">{opt.label}</span>
            <span className="statut-chip-nombre">{n}</span>
          </button>
        );
      })}
    </div>
  );
}

export default StatutsBarre;
